<template>
  <v-list class="eds-comp-filter-set">
    <v-layout row wrap style="height: 250px">
      <div style="width: 100%">
        <v-flex xs12>
          <div style="
              font-size: 14px;
              color: #bebebe;
              height: 30xp;
              line-height: 30px;
              margin-left: calc((100% - 21rem) / 4);
            ">
            <span>{{ title }}</span>
          </div>
        </v-flex>
        <v-flex xs12>
          <div :class="[{ isNoSelected: !item.isSelected, isSelected: item.isSelected },]"
            v-for="(item, index) in filterList" :key="index" :id="'filter' + index" @click="onSelectItem(item)">
            {{ item.name }}
          </div>
        </v-flex>
        <div style="
            position: absolute;
            bottom: 0;
            width: 100%;
            border-top: 1px solid #eaeaea;
            text-align: center;
          ">
          <div style="
              display: inline-block;
              width: 50%;
              height: 40px;
              line-height: 40px;
            " @click="onClear()">
            {{ $t('重置') }}
          </div>
          <div style="
              display: inline-block;
              width: 50%;
              height: 40px;
              line-height: 40px;
              background-color: rgb(48, 133, 214);
              color: white;
            " @click="onSave()">
            {{ $t('确定') }}
          </div>
        </div>
      </div>
    </v-layout>
  </v-list>
</template>


<script>
import msgbus from '../msgBus'

export default {
  name: 'eDS-CompFilterSet',
  props: {
    title: {
      type: String,
      default: '',
    },
    isMultiSelect: {
      type: Boolean,
      default: true,
    },
    inputFilterList: {
      type: Object,
      default: null,
    },
    inputFilterSetInfo: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      filterList: null,
      filterSetInfo: [],
    }
  },
  computed: {},
  methods: {
    // 选择项
    onSelectItem(item) {
      let isSelected = item.isSelected

      if (!this.isMultiSelect) {
        for (var key in this.filterList) {
          this.filterList[key].isSelected = false
        }
      }
      item.isSelected = !isSelected
    },
    // 重置
    onClear() {
      this.filterSetInfo = []
      for (var key in this.filterList) {
        this.filterList[key].isSelected = false

        var filterItem = this.inputFilterSetInfo.filter(
          (item) => item.name == this.filterList[key].name
        )
        if (filterItem.length > 0) {
          this.filterList[key].isSelected = true
        }
      }
    },
    // 保存
    onSave() {
      this.filterSetInfo = []
      for (var key in this.filterList) {
        if (this.filterList[key].isSelected) {
          this.filterSetInfo.push(this.filterList[key])
        }
      }
      // 读取过滤配置
      this.$emit('onSaveFilterSet', this.filterSetInfo)
    },
  },
  created() {
    console.log('调试代码')

    // 置初始状态
    this.filterList = { ...this.inputFilterList }
    for (var key in this.filterList) {
      // this.filterListTemp[key].isSelected = false // 注意：这样赋值页面不会侦听属性
      this.$set(this.filterList[key], 'isSelected', false) // 注意：这样赋值页面会侦听属性

      var filterItem = this.inputFilterSetInfo.filter(
        (item) => item.name == this.filterList[key].name
      )
      if (filterItem.length > 0) {
        this.filterList[key].isSelected = true
      }
    }
  },
  mounted() { },
  updated() { },
}
</script>


<style lang="scss">
.eds-comp-filter-set {
  z-index: 10000;

  .isNoSelected {
    float: left;
    padding: 0.5rem 0.5rem;
    width: 28%;
    margin: 0.5rem 0 0rem 4%;
    text-align: center;
    border-color: #eaeaea;
    border-style: solid;
    border-width: 1px;
    color: #505050;
    background: white;
  }

  .isSelected {
    float: left;
    padding: 0.5rem 0.5rem;
    width: 28%;
    margin: 0.5rem 0 0rem 4%;
    text-align: center;
    border-color: rgb(48, 133, 214);
    border-style: solid;
    border-width: 1px;
    color: rgb(48, 133, 214);
    background: white;
  }
}
</style>